import { Box, withStyles } from "@mui/material";
import React from "react";
import styles from "./styles";
import logoBlanc from "../../../../ressources/images/logo_vertuloo_blanc.png";

const BlocBackground = () => (
  <Box className={"container"} sx={styles}>
    <div className={"texte"}>
      <h2>En savoir plus sur</h2>
      <img src={logoBlanc} width={400} alt="" />
    </div>
  </Box>
);

export default BlocBackground;
